import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type Props = {
    startImport: () => Promise<void>;
    isDisabled?: boolean;
}

function ImportButton({ startImport, isDisabled = false }: Props) {
    return (
        <div>
            <Button
                disabled={isDisabled}
                onClick={startImport}
                className={cn(
                    "cursor-pointer text-base font-medium px-5 py-3 rounded-[5px]",
                    "text-white dark:text-white",
                    "bg-[#ff5722] hover:bg-[#ff5722]/90 dark:bg-[#ff5722] dark:hover:bg-[#ff5722]/90",
                    "disabled:text-[#8c8c8c] disabled:bg-transparent disabled:cursor-not-allowed",
                    "dark:disabled:text-[#8c8c8c] dark:disabled:bg-transparent"
                )}
            >
                Import
            </Button>
        </div>
    )
}

export default ImportButton